import React, { Component } from "react";
import { Navbar, Nav, NavItem, NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import HeaderLinks from "./HeaderLinks.jsx";
import dashboardRoutes from "../../routes/dashboard.jsx";
import logoPortoEduc from "../../assets/img/logoPortoEduc.png";
import { addToDataLayerGTM } from '../../utils/addToDataLayerGTM';

class Header extends Component {
  constructor(props) {
    super(props);
    this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
    this.handleGTMPodcast = this.handleGTMPodcast.bind(this);
    this.state = {
      sidebarExists: false
    };
  }
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }
  mobileSidebarToggle(e) {
    if (this.state.sidebarExists === false) {
      this.setState({
        sidebarExists: true
      });
    }
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function() {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  }

  handleGTMPodcast(prop) {
    return prop.name.includes('Podcasts')
      ? addToDataLayerGTM({
      'event': 'step_change',
      'etapa': '/podcasts/',})
      : null
  }

  render() {

    var logo = logoPortoEduc;

    if(window.location.host == 'salavirtual.sambalms.com.br') {
      return (
        <Navbar fluid>
          <Navbar.Header>
            <Navbar.Brand>
              <a><img id="logo_top" src={logo} /></a>
            </Navbar.Brand>
          </Navbar.Header>
        </Navbar>
      );
    }


    return (

      <Navbar fluid>
        <Navbar.Header>
          <Navbar.Brand>
            <a
            data-gtm-type="click"
            data-gtm-clicktype="menu"
            data-gtm-name="Início"
            href="/#/home"
            >
              <img id="logo_top" src={logo} />
              </a>
          </Navbar.Brand>
          <Navbar.Toggle onClick={this.mobileSidebarToggle} />
        </Navbar.Header>
        <Navbar.Collapse>
          <HeaderLinks />
          <Nav>

            {dashboardRoutes.map((prop, key) => {
                if (!prop.redirect && prop.showSidebar)
                  if(prop.children) {
                    return (
                    <li
                      className={
                          this.activeRoute(prop.path)
                      }
                      key={key}
                    >
                    <a>
                    <NavDropdown
                      title={prop.name}
                      id="basic-nav-dropdown-right"
                    >
                    {prop.children.map((prop, key) => {
                      return(
                      <NavItem
                        data-gtm-type="click"
                        data-gtm-clicktype="menu"
                        data-gtm-name={prop.name}
                        key={key}
                        to={prop.path}
                        className="nav-link"
                        activeClassName="active"
                        href={"/#"+prop.path}
                        onClick={() => this.handleGTMPodcast(prop)}
                        >
                          {prop.name}
                        </NavItem>
                      );
                    })}
                    </NavDropdown>
                    </a>
                    </li>
                    );
                  } else {
                  return (
                    <li
                      className={
                          this.activeRoute(prop.path)
                      }
                      key={key}
                    >
                      <NavLink
                        data-gtm-type="click"
                        data-gtm-clicktype="menu"
                        data-gtm-name={prop.name}
                        to={prop.path}
                        className="nav-link"
                        activeClassName="active"
                      >
                        {prop.name == "Início" ? <i className="ps-ico ps-ico-home" /> : prop.name}
                      </NavLink>
                    </li>
                  );
                }
            })}

          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx